export const MAINTENANCE_OWNER_EMAIL = "cjaystreamz@gmail.com";

export function normaliseEmail(value) {
  return String(value || "").trim().toLowerCase();
}

export function isMaintenanceOwner(sessionOrUser) {
  const user = sessionOrUser?.user || sessionOrUser || null;
  return normaliseEmail(user?.email) === MAINTENANCE_OWNER_EMAIL;
}

export function canBypassMaintenance(sessionOrUser, profile) {
  return isMaintenanceOwner(sessionOrUser) || profile?.position === "Management";
}

export function formatMaintenanceMessage(value) {
  const text = String(value || "").trim();
  return text || "This service is currently undergoing planned maintenance. Please check back shortly.";
}
